if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this._currentIndex = 0;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this._initNav();
      }

      showActiveMedia() {
        const mediaId = this.openedBy && this.openedBy.getAttribute('data-media-id');
        const allMedia = this.querySelectorAll('[data-media-id]');

        allMedia.forEach((el, i) => {
          el.classList.remove('active');
          if (el.getAttribute('data-media-id') === mediaId) {
            this._currentIndex = i;
          }
        });

        const activeMedia = mediaId
          ? this.querySelector(`[data-media-id="${mediaId}"]`)
          : allMedia[0];

        if (!activeMedia) return;
        activeMedia.classList.add('active');

        // Load YouTube if needed
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) activeMedia.loadContent();

        this._syncThumbs();
      }

      _getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      _goTo(index) {
        const items = this._getMediaItems();
        if (!items.length) return;
        if (index < 0) index = items.length - 1;
        if (index >= items.length) index = 0;

        items[this._currentIndex] && items[this._currentIndex].classList.remove('active');
        this._currentIndex = index;
        items[this._currentIndex].classList.add('active');
        this._syncThumbs();
      }

      _syncThumbs() {
        const thumbs = this.querySelectorAll('.modal-thumb');
        thumbs.forEach((t, i) => {
          t.classList.toggle('modal-thumb--active', i === this._currentIndex);
        });
        const activeThumb = thumbs[this._currentIndex];
        if (activeThumb) activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      _initNav() {
        if (this._navReady) return;
        this._navReady = true;

        // Arrows
        const prev = this.querySelector('.modal-arrow--prev');
        const next = this.querySelector('.modal-arrow--next');
        if (prev) prev.addEventListener('click', (e) => { e.stopPropagation(); this._goTo(this._currentIndex - 1); });
        if (next) next.addEventListener('click', (e) => { e.stopPropagation(); this._goTo(this._currentIndex + 1); });

        // Thumbnails
        this.querySelectorAll('.modal-thumb').forEach((thumb, i) => {
          thumb.addEventListener('click', (e) => { e.stopPropagation(); this._goTo(i); });
        });

        // Keyboard
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this._goTo(this._currentIndex - 1);
          if (e.key === 'ArrowRight') this._goTo(this._currentIndex + 1);
        });

        // Touch swipe
        let touchStartX = 0;
        const content = this.querySelector('.product-media-modal__content');
        if (content) {
          content.addEventListener('touchstart', (e) => { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
          content.addEventListener('touchend', (e) => {
            const diff = touchStartX - e.changedTouches[0].screenX;
            if (Math.abs(diff) > 50) this._goTo(this._currentIndex + (diff > 0 ? 1 : -1));
          }, { passive: true });
        }
      }
    }
  );
}
